import { render, staticRenderFns } from "./testDetail.vue?vue&type=template&id=cb797180"
import script from "./testDetail.vue?vue&type=script&lang=js"
export * from "./testDetail.vue?vue&type=script&lang=js"
import style0 from "./testDetail.vue?vue&type=style&index=0&id=cb797180&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports